import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-without-animation-home-six',
    templateUrl: './without-animation-home-six.component.html',
    styleUrls: ['./without-animation-home-six.component.scss'],
    standalone: false
})
export class WithoutAnimationHomeSixComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
